<!-- страница-курса -->
<!-- src\components\U1089u1090u1088u1072u1085u1080u10944.vue -->

<template>
	<div class="container-center-horizontal">
		<div
			class="u1089u1090u1088u1072u1085u1080u1094u1072-u1082u1091u1088u1089u1072 screen"
		>
			<div class="x-42">
				<header6
					:className="header6Props.className"
					:view30Props="header6Props.view30Props"
				/>
				<div class="view-521">
					<group443
						:x1821Props="group443Props.x1821Props"
						:x1822Props="group443Props.x1822Props"
						:x3621Props="group443Props.x3621Props"
						:x3622Props="group443Props.x3622Props"
						:x3623Props="group443Props.x3623Props"
					/>
					<!-- Индикатор загрузки -->
					<div v-if="loading" class="course-loading-page">
						<div class="spinner-page"></div>
						<p>Загрузка курса...</p>
					</div>

					<!-- Ошибка загрузки -->
					<div v-else-if="error" class="course-error-page">
						<p>{{ error }}</p>
						<button
							@click="$router.push('/student-dashboard')"
							class="btn-back-page"
						>
							Вернуться к курсам
						</button>
					</div>

					<!-- Данные курса -->
					<div v-else-if="course" class="view-522">
						<img
							class="rectangle-59"
							:src="
								course.cover_image_url ||
								'https://via.placeholder.com/1362x846/0095ec/ffffff?text=Курс'
							"
							:alt="course.title"
						/>
						<view48 v-bind="view48Props" />
						<div class="view-523">
							<div
								class="rectangle-81-45"
								@click="enrollInCourse"
								style="cursor: pointer"
							></div>
							<div class="text-632 poppins-bold-azure-radiance-15px">
								{{
									course.is_enrolled
										? 'Продолжить обучение'
										: 'Записаться на курс'
								}}
							</div>
						</div>
						<view372
							:className="view372Props.className"
							:view5Props="view372Props.view5Props"
						/>
						<view49 />
						<view362 :className="view362Props.className" />
						<img
							class="image-53"
							:src="
								course.teacher_avatar ||
								'https://via.placeholder.com/150/0095ec/ffffff?text=Teacher'
							"
							alt="Преподаватель"
						/>
						<div class="text-639 poppins-normal-black-40px">
							{{ course.teacher_name || 'Преподаватель не указан' }}
						</div>
						<p class="text-640 poppins-bold-black-50px">{{ course.title }}</p>
						<router-link to="/student-dashboard">
							<p class="text_label-43 poppins-extra-extra-bold-black-20px">
								<span class="span-19 poppins-extra-extra-bold-black-20px">{{
									spanText1
								}}</span
								><span class="span-19 poppins-thin-black-20px">{{
									spanText2
								}}</span
								><span class="span-19 poppins-extra-extra-bold-black-20px">{{
									spanText3
								}}</span
								><span class="span-19 poppins-normal-black-20px-2">{{
									spanText4
								}}</span
								><span class="span-19 poppins-thin-black-20px">{{
									spanText5
								}}</span
								><span class="span-19 poppins-normal-black-20px-2">{{
									spanText6
								}}</span
								><span class="span-19 poppins-extra-extra-bold-black-20px">{{
									spanText7
								}}</span
								><span class="span-19 poppins-normal-black-20px-2">{{
									spanText8
								}}</span
								><span class="span-19 poppins-thin-black-20px">{{
									spanText9
								}}</span
								><span class="span-19 poppins-normal-black-20px-2">{{
									spanText10
								}}</span
								><span class="span-19 poppins-extra-extra-bold-black-20px">{{
									spanText11
								}}</span
								><span class="span-19 poppins-normal-black-20px-2">{{
									spanText12
								}}</span>
							</p>
						</router-link>
					</div>
				</div>
				<div class="view-524">
					<div class="x25-48 poppins-bold-black-40px">{{ x25 }}</div>
					<div class="view-525">
						<x1162 :view79Props="x11621Props.view79Props" />
						<x1162
							:className="x11622Props.className"
							:view79Props="x11622Props.view79Props"
						/>
						<div class="x1-85">
							<div class="group-245-5">
								<div class="group-50-4">
									<div class="group-40-3">
										<img
											class="rectangle-32-1"
											:src="rectangle32"
											alt="Rectangle 32"
										/><router-link to="/video-lessons"
											><img
												class="rectangle-38-3"
												:src="rectangle38"
												alt="Rectangle 38"
										/></router-link>
									</div>
									<view792
										:spanText1="view792Props.spanText1"
										:spanText2="view792Props.spanText2"
										:className="view792Props.className"
									/>
								</div>
							</div>
							<group273 />
							<div class="text-626 poppins-semi-bold-black-14px">
								{{ text626 }}
							</div>
						</div>
						<x1162
							:className="x11623Props.className"
							:view79Props="x11623Props.view79Props"
						/>
						<x1162
							:className="x11624Props.className"
							:view79Props="x11624Props.view79Props"
						/>
						<x1172 />
					</div>
					<group248 :className="group248Props.className" />
				</div>
				<view802 v-bind="view802Props" />
				<div class="view-526">
					<footer class="footer-5">
						<div class="rectangle-80-17"></div>
						<p class="copyright-5 poppins-normal-boulder-22px">
							<span class="span-20 poppins-normal-boulder-22px">{{
								spanText13
							}}</span
							><span class="span1-15 poppins-normal-boulder-22px">{{
								spanText14
							}}</span
							><span class="span-20 poppins-normal-boulder-22px">{{
								spanText15
							}}</span>
						</p>
						<div class="group-496-4">
							<div class="view-527">
								<group463 :className="group463Props.className" />
								<group461 :className="group461Props.className" />
								<div class="group-462-5">
									<div class="text-569 poppins-semi-bold-white-22px">
										{{ text569 }}
									</div>
									<a href="mailto:project@metall-trade.ru" target="_blank">
										<div
											class="projectmetall-traderu-5 poppins-normal-boulder-22px"
										>
											{{ projectMetallTradeRu }}
										</div> </a
									><a href="tel:+74951362515" target="_blank">
										<div class="phone-6 poppins-normal-boulder-22px">
											{{ phone }}
										</div> </a
									><a href="https://project.metall-trade.ru/" target="_blank">
										<p class="text-568 poppins-normal-boulder-22px">
											{{ text568 }}
										</p>
									</a>
								</div>
							</div>
							<x3 :image="x3Props.image" :className="x3Props.className" />
							<div class="text-580 poppins-medium-white-9-5px">
								{{ text580 }}
							</div>
						</div>
					</footer>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Header6 from './Header6'
import Group443 from './Group443'
import View48 from './View48'
import View372 from './View372'
import View49 from './View49'
import View362 from './View362'
import X1162 from './X1162'
import View792 from './View792'
import Group273 from './Group273'
import X1172 from './X1172'
import Group248 from './Group248'
import View802 from './View802'
import Group463 from './Group463'
import Group461 from './Group461'
import X3 from './X3'
export default {
	name: 'U1089u1090u1088u1072u1085u1080u10944',
	components: {
		Header6,
		Group443,
		View48,
		View372,
		View49,
		View362,
		X1162,
		View792,
		Group273,
		X1172,
		Group248,
		View802,
		Group463,
		Group461,
		X3,
	},
	data() {
		return {
			course: null,
			loading: true,
			error: null,
		}
	},
	async mounted() {
		await this.loadCourse()
	},
	methods: {
		async loadCourse() {
			this.loading = true
			this.error = null

			try {
				// Получаем ID курса из query параметров
				const courseId = this.$route.query.id

				if (!courseId) {
					this.error = 'ID курса не указан'
					return
				}

				// Загружаем данные курса
				const { coursesService } = await import('@/services/courses')
				// coursesService.getById уже возвращает объект курса (response.data обрабатывается в сервисе)
				const courseData = await coursesService.getById(courseId)

				console.log('📦 Данные курса:', courseData)

				// Валидация полученных данных
				if (!courseData || !courseData.id) {
					console.error('❌ Некорректные данные курса:', courseData)
					this.error = 'Не удалось найти данные курса'
					return
				}

				this.course = courseData
				console.log('✅ Курс успешно загружен:', this.course)
			} catch (error) {
				console.error('❌ Ошибка загрузки курса:', error)
				if (error.response?.status === 401) {
					this.error = 'Необходимо авторизоваться для просмотра курса'
				} else if (error.response?.status === 404) {
					this.error = 'Курс не найден'
				} else {
					this.error =
						'Не удалось загрузить данные курса. Проверьте подключение к серверу.'
				}
			} finally {
				this.loading = false
			}
		},

		async enrollInCourse() {
			if (!this.course) return

			try {
				const { coursesService } = await import('@/services/courses')
				const { useAppStore } = await import('@/stores/useAppStore')
				const appStore = useAppStore()
				const user = appStore.user?.value || appStore.user

				if (!user || !user.id) {
					appStore.showError('Необходимо авторизоваться')
					this.$router.push('/auth')
					return
				}

				await coursesService.enroll(this.course.id)
				appStore.showSuccess('Вы успешно записались на курс!')

				// Перезагружаем данные курса
				await this.loadCourse()
			} catch (error) {
				console.error('❌ Ошибка записи на курс:', error)
				const { useAppStore } = await import('@/stores/useAppStore')
				const appStore = useAppStore()
				appStore.showError('Не удалось записаться на курс')
			}
		},
	},
	props: [
		'text632',
		'image',
		'text639',
		'text640',
		'spanText1',
		'spanText2',
		'spanText3',
		'spanText4',
		'spanText5',
		'spanText6',
		'spanText7',
		'spanText8',
		'spanText9',
		'spanText10',
		'spanText11',
		'spanText12',
		'x25',
		'rectangle32',
		'rectangle38',
		'text626',
		'spanText13',
		'spanText14',
		'spanText15',
		'text569',
		'projectMetallTradeRu',
		'phone',
		'text568',
		'text580',
		'header6Props',
		'group443Props',
		'view48Props',
		'view372Props',
		'view362Props',
		'x11621Props',
		'x11622Props',
		'view792Props',
		'x11623Props',
		'x11624Props',
		'group248Props',
		'view802Props',
		'group463Props',
		'group461Props',
		'x3Props',
	],
}
</script>

<style>
.u1089u1090u1088u1072u1085u1080u1094u1072-u1082u1091u1088u1089u1072 {
	align-items: flex-start;
	background-color: var(--white);
	display: flex;
	width: 1920px;
}

.x-42 {
	display: flex;
	flex-direction: column;
	height: 3257px;
	position: relative;
	width: 1920px;
}

.view-521 {
	display: flex;
	gap: 11px;
	margin-left: 66px;
	margin-top: 65px;
	position: relative;
	width: 1788px;
}

.view-522 {
	height: 846px;
	position: relative;
	width: 1368px;
}

.rectangle-59 {
	height: 846px;
	left: 0;
	position: absolute;
	top: 0;
	width: 1362px;
}

.view-523 {
	height: 50px;
	left: 91px;
	position: absolute;
	top: 500px;
	width: 202px;
}

.rectangle-81-45 {
	border: 1px solid;
	border-color: var(--azure-radiance);
	border-radius: 10px;
	cursor: pointer;
	height: 50px;
	left: 0;
	position: absolute;
	top: 0;
	width: 200px;
}

.text-632 {
	left: 24px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: 13px;
}

.image-53 {
	height: 604px;
	left: 770px;
	position: absolute;
	top: 31px;
	width: 572px;
}

.text-639 {
	left: 91px;
	letter-spacing: 0.8px;
	line-height: normal;
	position: absolute;
	top: 239px;
}

.text-640 {
	left: 91px;
	letter-spacing: 1px;
	line-height: normal;
	position: absolute;
	top: 108px;
}

.text_label-43 {
	cursor: pointer;
	left: 91px;
	letter-spacing: 0.4px;
	line-height: 36px;
	position: absolute;
	top: 36px;
	white-space: nowrap;
}

.span-19 {
	letter-spacing: 0.08px;
}

.view-524 {
	display: flex;
	flex-direction: column;
	height: 938px;
	margin-left: 88px;
	margin-top: 42px;
	position: relative;
	width: 1656.21px;
}

.x25-48 {
	height: 72px;
	letter-spacing: 0.8px;
	line-height: 72px;
	white-space: nowrap;
	width: 301px;
}

.view-525 {
	height: 755px;
	margin-top: 22px;
	position: relative;
	width: 1654px;
}

.x1-85 {
	height: 367px;
	left: 1115px;
	position: absolute;
	top: 2px;
	width: 532px;
}

.group-245-5 {
	align-items: flex-start;
	background-color: var(--white);
	border-radius: 20px;
	box-shadow: 0px 18.83px 47.08px #2f327d1a;
	display: flex;
	height: 367px;
	justify-content: flex-end;
	left: 0;
	min-width: 530px;
	padding: 19.6px 20.9px;
	position: absolute;
	top: 0;
}

.group-50-4 {
	height: 258px;
	position: relative;
	width: 488px;
}

.group-40-3 {
	display: flex;
	gap: 45615.9px;
	height: 258px;
	left: 0;
	position: absolute;
	top: 0;
	width: 488px;
}

.rectangle-32-1 {
	height: 258.38px;
	margin-left: 0.9px;
	object-fit: cover;
	width: 487.22px;
}

.rectangle-38-3 {
	cursor: pointer;
	height: 258.38px;
	margin-top: -8356px;
	width: 487.22px;
}

.text-626 {
	left: 406px;
	letter-spacing: 0.28px;
	line-height: normal;
	position: absolute;
	top: 327px;
	width: 102px;
}

.view-526 {
	display: flex;
	margin-top: 96px;
	width: 1920px;
}

.footer-5 {
	background-color: transparent;
	position: relative;
	width: 1922px;
}

.rectangle-80-17 {
	background-color: var(--thunder);
	height: 600px;
	left: 0;
	position: absolute;
	top: 0;
	width: 1920px;
}

.copyright-5 {
	left: calc(50% - 182px);
	letter-spacing: 0.88px;
	line-height: normal;
	position: absolute;
	text-align: center;
	top: 529px;
}

.span-20 {
	letter-spacing: 0.19px;
}

.span1-15 {
	letter-spacing: 0.19px;
	text-decoration: underline;
}

/* Стили для загрузки и ошибок на странице курса */
.course-loading-page,
.course-error-page {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 500px;
	padding: 40px;
	background: white;
	border-radius: 12px;
	margin: 20px;
}

.spinner-page {
	width: 60px;
	height: 60px;
	border: 5px solid #f3f3f3;
	border-top: 5px solid var(--azure-radiance);
	border-radius: 50%;
	animation: spin 1s linear infinite;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

.course-loading-page p,
.course-error-page p {
	margin-top: 20px;
	font-size: 20px;
	color: var(--thunder);
}

.btn-back-page {
	margin-top: 20px;
	padding: 12px 30px;
	background-color: var(--azure-radiance);
	color: white;
	border: none;
	border-radius: 8px;
	font-size: 16px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.3s ease;
}

.btn-back-page:hover {
	background-color: #0077cc;
	transform: scale(1.05);
}

.group-496-4 {
	height: 207px;
	left: 165px;
	position: absolute;
	top: 165px;
	width: 1590px;
}

.view-527 {
	display: flex;
	gap: 190px;
	height: 207px;
	left: 280px;
	position: absolute;
	top: 0;
	width: 1308px;
}

.group-462-5 {
	display: flex;
	flex-direction: column;
	height: 160px;
	width: 466px;
}

.text-569 {
	height: 33px;
	letter-spacing: 0.88px;
	line-height: normal;
	width: 156px;
}

.projectmetall-traderu-5 {
	cursor: pointer;
	height: 33px;
	letter-spacing: 0.88px;
	line-height: normal;
	margin-top: 7px;
	text-align: center;
	text-decoration: underline;
	width: 288px;
}

.phone-6 {
	cursor: pointer;
	height: 33px;
	letter-spacing: 0.88px;
	line-height: normal;
	margin-top: 11px;
	text-align: center;
	text-decoration: underline;
	width: 221px;
}

.text-568 {
	cursor: pointer;
	height: 33px;
	letter-spacing: 0.88px;
	line-height: normal;
	margin-top: 10px;
	text-align: center;
	text-decoration: underline;
	width: 458px;
}

.text-580 {
	left: 0;
	letter-spacing: 0.38px;
	line-height: normal;
	position: absolute;
	text-align: center;
	top: 77px;
}
</style>
